import localFetch from "@/modules/instances/localFetch";

/**
 * Local/self-hosted mode: there is no separate control-plane user id — the
 * local backend's own user id (GET /v1/users/me) is the one that owns the
 * API keys. See getApiKeys.ts for why this replaces the upstream OSS stub
 * (previously always returned null).
 */
export default async function getMyUserId(): Promise<string | null> {
  try {
    const response = await localFetch("/v1/users/me", { method: "GET" });
    const data = await response.json();
    return data?.id || null;
  } catch {
    return null;
  }
}
